<template>

  <t-page>

    <t-page-form multi-cards submit-text="Operação Manual"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">

        <t-form-card title="Dados Básicos">

          <t-input v-model="form.inOutType" :disabled="!enableChooseOperation" required label="Operação" radio
                   :options="stockInOutOptions"/>

          <t-input v-if="form.inOutType === StockInOutType.type.IN" v-model="form.stockManualId"
                   select  :options="stockManualInOptions" required
                   label="Motivo Entrada Manual"/>

          <t-input v-else v-model="form.stockManualId" select
                   :options="stockManualOutOptions" required
                   label="Motivo Saída Manual"/>


          <slot name="product" v-if="form.inOutType === StockInOutType.type.IN || !disabledOutIndividualProduct">

            <b-row>

              <b-col cols="9">
                <t-input-product :status="status" :command="command" @change="getSource()" v-model="form.productId"
                                 required/>
              </b-col>

              <t-input cols="3" v-model="form.quantity" required label="Qtd." number decimals="3"/>

            </b-row>

          </slot>

          <b-row>

            <t-input cols="4" v-model="form.stockPlaceProductInsideId" @change="getSource()" select
                     :options="stockPlaceProductInsideOptions" first-default
                     required label="Local de Armazenamento"/>

            <t-input cols="4" v-model="form.companyId" select :options="companyOptions" required label="Empresa"/>

            <t-input cols="4" v-model="form.issueDate" required label="Data de Emissão" date date-now/>

          </b-row>

          <b-row v-if="form.inOutType === StockInOutType.type.OUT && !onlySourceExact">

            <b-col>

              <b-form-checkbox switch v-model="form.enableChooseOut">

                Escolher a fonte exata para saída dos produtos
                <t-help
                    title="Utilize esta opção para especificar de onde será feita a saída do estoque, ou deixe desmarcado que o sistema fará a escolha automaticamente com base nos itens mais antigo no estoque."/>
              </b-form-checkbox>

            </b-col>


          </b-row>

        </t-form-card>


        <t-form-card v-if="form.inOutType === StockInOutType.type.OUT && form.enableChooseOut"
                     title="Especificar Saída">


          <t-msg warning
                 v-if="(!disabledOutIndividualProduct && (form.productId === 0 || form.stockPlaceProductInsideId === 0)) || (disabledOutIndividualProduct && (sourceOutIsLoaded && form.stockPlaceProductInsideId === 0))">
            <slot name="sourceTextNotEnabled">Selecione um produto e uma
              localização de estoque para listar as opções disponíveis
            </slot>
          </t-msg>
          <t-msg danger v-else-if="sourceOutIsLoaded && sourceOutOptions.length === 0">Nenhum produto disponível em
            estoque de acordo com o produto e localização escolhidos
          </t-msg>

          <t-loading v-if="!sourceOutIsLoaded"/>

          <table v-else-if="sourceOutOptions.length > 0" class="table table-hover">
            <thead>
            <th v-for="field in fields" :key="field.key">{{ field.label }}</th>
            </thead>

            <tbody>

            <tr v-for="(item,index) in sourceOutOptions" :key="index">

              <td class="d-flex">
                <t-input checked v-model="item.value" :label="item.originCodeLabel"
                         :id="'originCodeLabel_'+item.stockProductId"/>
              </td>

              <td v-for="field in fields.filter(a => a.key !== 'originCodeLabel')" :key="field.key">
                <t-table-field :column="field.key" :item="item" :formatter="field.formatter"/>
              </td>

            </tr>

            </tbody>

          </table>

        </t-form-card>

        <t-form-card title="Outras Informações">

          <b-row v-if="form.inOutType === StockInOutType.type.IN">

            <t-input cols="6" v-model="form.originCodeLabel" label="Cód. Origem"
                     help="Insira alguma identificação de código que facilite a escolha por este item no futuro"/>
            <t-input cols="6" v-model="form.producedWeight" label="Peso"
                     help="Insira o peso para facilitar a busca, caso desejado"/>
          </b-row>


          <t-input class="mt-2" v-model="form.stockManualNote" label="Observações" max-length="500" textarea/>

        </t-form-card>


      </template>


    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import http from "@/services/config/http-common";
import StockInOutType from "@/model/types/modules/stock/StockInOutType";
import StockProductService from "@/services/modules/stock/StockProduct.service";
import ui from "@/assets/scripts/ui";
import pageFormEmbeddableMixin from "@/mixins/page/pageFormEmbeddableMixin";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormEmbeddableMixin],

  name: 'StockProductManualFormEmbeddable',
  data() {
    return {
      StockInOutType,
      path: "stock/product", //Utilizar somente quando fora do padrão
      fieldKey: "inOutType",
      error: {//Campos que podem receber retorno de erro do backend

      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      sourceOutQuantity: 0.0, /*Quantidade selecionada*/
      sourceOutIsLoaded: true,
      sourceOutOptions: [],
      enableChooseOperation: false,
      stockManualInOptions: [],
      stockManualOutOptions: [],
      stockPlaceProductInsideOptions: [],
      companyOptions: [],
      stockInOutOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    sourceOrderBy: String,
    onlySourceExact: Boolean,
    disabledOutIndividualProduct: Boolean,
    fields: [],
  },
  methods: {

    mountedPrepare() {

      this.mountedPrepareEmbeddable()
    },
    async mountedContinued() {

      if (this.relationAccessSubValidation('sub-action-in-manual') && this.relationAccessSubValidation('sub-action-out-manual')) {
        //Poderá selecionar entrada ou saída
        this.enableChooseOperation = true
        this.form.inOutType = StockInOutType.type.OUT //Padrão saída por definição
        this.stockInOutOptions = StockInOutType.list
      } else if (this.relationAccessSubValidation('sub-action-in-manual')) {
        //Somente entrada
        this.form.inOutType = StockInOutType.type.IN
      } else if (this.relationAccessSubValidation('sub-action-out-manual')) {
        this.form.inOutType = StockInOutType.type.OUT
      } else {
        ui.msgError(this, "Erro validação de acesso para realização de operação manual não encontrada", () => {
          this.goPath(this.currentPage.path)
        })
      }

      await http.list(this.path + "/selectRelationList").then((response) => {

        this.stockManualInOptions = response.stockManualInOptions
        this.stockManualOutOptions = response.stockManualOutOptions
        this.stockPlaceProductInsideOptions = response.stockPlaceProductInsideOptions
        this.companyOptions = response.companyOptions

      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true
      this.setIsLoadingPage(false)

      await this.mountedContinuedEmbeddable() //Deixar sempre no final

    },
    async onSubmit() {

      if (this.form.enableChooseOut && this.form.inOutType === StockInOutType.type.OUT) {

        /*------------------*/
        /*Injeta campos selecionados em sourceOut*/

        for (const item of this.sourceOutOptions) {

          if (item.value !== undefined && item.value !== null && item.value) {
            this.sourceOutQuantity += item.quantityAvailable /*Por enquanto está pré-determinado a mesma qtd. disponível para saída, porém no futuro deverá informar se deseja saída parcial, caso a qtd disponível <> 1*/
            this.form.sourceOut.push({
              stockProductId: item.stockProductId,
              quantity: item.quantityAvailable /*Por enquanto está pré-determinado a mesma qtd. disponível para saída, porém no futuro deverá informar se deseja saída parcial, caso a qtd disponível <> 1*/
            })
          }

        }

        //Troca a qtd. informada pela selecionada pela fonte por consistência de informações
        if (this.sourceOutQuantity > 0) {
          this.form.quantity = this.sourceOutQuantity
        } else {
          this.form.quantity = 1
        }
        /*------------------*/

        if (this.form.sourceOut.length === 0) {
          ui.msgError(this, "Você escolha a opção de saída com origem especificada, porém não relacionou qual a origem para saída. Verifique se o produto e localização de estoque possuem itens disponíveis para escolha com origem")
        } else {
          await this.returnRedirect()
        }

      } else {
        await this.returnRedirect()
      }

    },
    //--------------------------------------------------------------------------------------

    async returnRedirect() {

      await this.setSending(
          this.form.inOutType,
          (response) => {
            this.setRedirect(this.currentPage.path, response[this.fieldKey], this.command, 0, "", true)
          },
      )

    },

    //Início de métodos personalizados desta tela
    async getSource() {


      let valid = false

      if (this.disabledOutIndividualProduct) {
        //Validação sem considerar o produto

        if (this.form.stockPlaceProductInsideId > 0 && this.form.enableChooseOut && this.form.inOutType === StockInOutType.type.OUT) {
          valid = true
        }

      } else {
        //Validação considerando o produto

        if (this.form.productId > 0 && this.form.stockPlaceProductInsideId > 0 && this.form.enableChooseOut && this.form.inOutType === StockInOutType.type.OUT) {
          valid = true
        }

      }


      if (valid) {

        this.sourceOutIsLoaded = false

        await StockProductService.findSource(this.form.productId, this.form.stockPlaceProductInsideId, this.sourceOrderBy).then(response => {

          this.sourceOutOptions = response
          this.sourceOutIsLoaded = true

        })

      } else {
        this.sourceOutOptions = []
      }

    }

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(false, false)

    await this.mountedContinued()

  },

}
</script>
